import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1ebc5ee6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "Border",
  fill: "none",
  viewBox: "0 0 240 62"
}
const _hoisted_2 = { class: "UIBtnPrimary__Inner" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "Background" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "BackgroundBlur" }, null, -1))
const _hoisted_5 = { class: "Label small-caps" }
const _hoisted_6 = {
  key: 0,
  class: "Border Border--inner",
  fill: "none",
  viewBox: "0 0 240 62",
  preserveAspectRatio: "none"
}

import { ref, withDefaults } from 'vue'
import { gsap } from 'gsap'
import { setFPS } from '@/utils/FrameToTime'
import AudioManager, { AUDIO_ID } from '@/core/audio/AudioManager'

interface Props {
  variant?: VARIANT
  theme?: THEME
}


import { defineComponent, nextTick, onMounted } from 'vue'

export const enum VARIANT {
  NORMAL = 'normal',
  OUTLINE = 'outline'
}

export const enum THEME {
  LIGHT = 'light',
  DARK = 'dark'
}

const __default__ = defineComponent({})

function setup(__props: any) {

const props = __props as { variant: VARIANT, theme: THEME }



const frames = setFPS(60)

const border = ref<SVGRectElement>(null)
const root = ref<HTMLButtonElement>(null)
const borderAnim = ref<SVGRectElement>(null)
const labelInner = ref<HTMLElement>(null)

function getRectLength(el: SVGRectElement) {
  return el.getTotalLength()
}

function onEnter(el: HTMLElement, onComplete: GSAPCallback) {
  const tl = gsap.timeline({
    onComplete
  })
  tl
    .fromTo(border.value, {
      strokeDashoffset: 1
    }, {
      strokeDashoffset: 0,
      duration: frames(36),
      ease: 'quint.inOut'
    })
    .from(labelInner.value, {
      yPercent: 100,
      duration: frames(31 - 15),
      ease: 'quart.out'
    }, frames(15))
}

function onMouseEnter() {

  if (!borderAnim.value) return

  AudioManager.playUI("ui_rollover_long");
  
  const width = root.value.offsetWidth
  const height = root.value.offsetHeight
  const d = width * 2 + height * 2
  
  const tl = gsap.timeline()
  tl
    .fromTo(borderAnim.value, {
      strokeDasharray: `0 ${0.16*d}`,
      strokeDashoffset: d*0.05
    }, {
      strokeDasharray: `${d * 0.1} ${0.12*d}`,
      strokeDashoffset: d*0.04,
      duration: frames(39),
      ease: 'quint.in'
    })
    .to(borderAnim.value, {
      strokeDasharray: `0 ${0.16*d}`,
      strokeDashoffset: d*-0.11,
      duration: frames(39),
      ease: 'quint.out'
    })

}

function onClick(){
    AudioManager.playUI("ui_click");
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, {
    css: false,
    onEnter: onEnter,
    onMouseenter: onMouseEnter,
    onClick: onClick
  }, {
    default: _withCtx(() => [
      _createElementVNode("button", {
        class: _normalizeClass(["UIBtn UIBtnPrimary", [
        `UIBtnPrimary--${__props.variant}`,
        `UIBtnPrimary--${__props.theme}`
      ]]),
        ref: (_value, _refs) => {
          _refs['root'] = _value
          root.value = _value
        }
      }, [
        (__props.variant === VARIANT.OUTLINE)
          ? (_openBlock(), _createElementBlock("svg", _hoisted_1, [
              _createElementVNode("rect", {
                ref: (_value, _refs) => {
                  _refs['border'] = _value
                  border.value = _value
                },
                x: "0.5",
                y: "0.5",
                width: "239",
                height: "61",
                pathLength: "1",
                rx: "24"
              }, null, 512)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _hoisted_4,
          _createElementVNode("span", _hoisted_5, [
            _createElementVNode("span", {
              ref: (_value, _refs) => {
                _refs['labelInner'] = _value
                labelInner.value = _value
              },
              class: "Label__Inner Label__Inner--main"
            }, [
              _renderSlot(_ctx.$slots, "default")
            ], 512),
            _createElementVNode("span", {
              ref: (_value, _refs) => {
                _refs['labelInnerClone'] = _value
              },
              class: "Label__Inner Label__Inner--clone"
            }, [
              _renderSlot(_ctx.$slots, "default")
            ], 512)
          ]),
          (__props.variant === VARIANT.NORMAL)
            ? (_openBlock(), _createElementBlock("svg", _hoisted_6, [
                _createElementVNode("rect", {
                  ref: (_value, _refs) => {
                    _refs['borderAnim'] = _value
                    borderAnim.value = _value
                  },
                  class: "ok",
                  x: "0.5",
                  y: "0.5",
                  width: "239",
                  height: "61",
                  pathLength: "100",
                  rx: "24",
                  stroke: "var(--white)"
                }, null, 512)
              ]))
            : _createCommentVNode("", true)
        ])
      ], 2)
    ]),
    _: 3
  }))
}
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    variant: { default: VARIANT.NORMAL },
    theme: { default: THEME.LIGHT }
  },
  setup})